(function () {
  // Barra de aviso: cerrar y recordar
  document.querySelectorAll('[data-announcement-close]').forEach(function (btn) {
    var bar = btn.closest('.announcement');
    try { if (sessionStorage.getItem('am-announcement-closed')) bar.classList.add('is-hidden'); } catch (e) {}
    btn.addEventListener('click', function () {
      bar.classList.add('is-hidden');
      try { sessionStorage.setItem('am-announcement-closed', '1'); } catch (e) {}
    });
  });

  // Menú móvil y búsqueda
  function toggle(btnSel, targetSel) {
    document.querySelectorAll(btnSel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = document.querySelector(targetSel);
        if (!t) return;
        var open = t.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
        if (open) { var i = t.querySelector('input'); if (i) i.focus(); }
      });
    });
  }
  toggle('[data-menu-toggle]', '#MobileNav');
  toggle('[data-search-toggle]', '#SearchDrawer');

  // Selectores de cantidad
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 0;
        var min = parseInt(input.min || '0', 10);
        v = b.dataset.step === 'up' ? v + 1 : Math.max(min, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Carrito: actualizar al cambiar cantidad
  document.querySelectorAll('[data-cart-autosubmit] input[name="updates[]"]').forEach(function (i) {
    i.addEventListener('change', function () { i.form.submit(); });
  });

  // Filtros: enviar al cambiar y cerrar desplegables al hacer clic fuera
  document.querySelectorAll('[data-facets-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function (v, k) { if (v !== '') params.append(k, v); });
      window.location.search = params.toString();
    });
    var details = form.querySelectorAll('details.facet');
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) details.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) details.forEach(function (d) { d.open = false; });
    });
  });

  // Página de producto: galería y variantes
  var product = document.querySelector('[data-product]');
  if (!product) return;

  var main = product.querySelector('.js-main-image');
  product.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      main.src = t.dataset.src;
      main.srcset = '';
      product.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  var jsonEl = product.querySelector('[data-product-json]');
  if (!jsonEl) return;
  var data = JSON.parse(jsonEl.textContent);
  var selects = product.querySelectorAll('[data-option-index]');
  var idInput = product.querySelector('input[name="id"]');
  var priceEl = product.querySelector('[data-price]');
  var addBtn = product.querySelector('[data-add-button]');
  var fmt = function (cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: data.currency });
  };

  function update() {
    var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
    var v = data.variants.find(function (x) {
      return x.options.every(function (o, i) { return o === opts[i]; });
    });
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.unavailable;
      return;
    }
    idInput.value = v.id;
    priceEl.innerHTML = v.compare_at_price > v.price
      ? '<span class="price--sale">' + v.price_html + '</span><s>' + v.compare_html + '</s>'
      : v.price_html;
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
    if (v.featured_image && main) { main.src = v.featured_image; main.srcset = ''; }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  }
  selects.forEach(function (s) { s.addEventListener('change', update); });
})();


/* ---------- Carrito lateral ---------- */
(function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer || document.body.dataset.cartDrawerEnabled !== 'true') return;
  var overlay = document.querySelector('.drawer-overlay');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function open() {
    drawer.classList.add('is-open'); overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
  }
  function close() {
    drawer.classList.remove('is-open'); overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
  }
  function refresh() {
    return fetch(root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var inner = html.querySelector('[data-cart-drawer-inner]');
        var current = drawer.querySelector('[data-cart-drawer-inner]');
        if (inner && current) current.replaceWith(inner);
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
    if (e.target.closest('[data-cart-open]')) {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); open(); return;
    }
    var line = e.target.closest('[data-line-change]');
    if (line) {
      e.preventDefault();
      drawer.classList.add('is-loading');
      fetch(root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line.dataset.lineChange, 10), quantity: Math.max(0, parseInt(line.dataset.qty, 10)) })
      }).then(refresh).finally(function () { drawer.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refresh(); })
      .then(open)
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Error'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  });
})();

/* ---------- Búsqueda predictiva ---------- */
(function () {
  if (document.body.dataset.predictive !== 'true') return;
  var input = document.querySelector('[data-psearch-input]');
  var box = document.querySelector('[data-psearch-results]');
  if (!input || !box) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer, last = '';
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { box.innerHTML = ''; last = ''; return; }
    timer = setTimeout(function () {
      if (q === last) return; last = q;
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][prefix]=last&section_id=predictive-search';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        if (input.value.trim() !== q) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var res = doc.querySelector('.psearch');
        box.innerHTML = res ? res.outerHTML : '';
      });
    }, 220);
  });
})();
